import React, {Fragment, useMemo} from 'react';
import {NavLink} from 'react-router-dom';
import {Box, Collapse, List, ListItemButton, ListItemIcon, ListItemText} from '@mui/material';
//
import {ExpandLessIcon, ExpandMoreIcon} from '../common/icons';
import {menu} from './menuConfig';
import {styled} from '@mui/material/styles';
import {useBoolFlag} from 'hooks/index';


const StyledLinkItemButton = styled(ListItemButton)(({theme}) => ({
    ['&:has(+.MuiCollapse-root &.active), &.active']: {
        color: theme.palette.primary.main,
        backgroundColor: 'rgba(0,0,0,0.04)',
        ['& .MuiSvgIcon-root']: {
            color: theme.palette.primary.main,
        },
    },
    '& + .MuiCollapse-root &': {},
}));

const MenuItem = ({menuItem}) =>
    menuItem.items.length ?
      <MultiLevel item={menuItem} /> :
      <SingleLevel item={menuItem} />;

const SingleLevel = ({item}) =>
    (
      <StyledLinkItemButton component={NavLink} to={item.link}>
        <ListItemIcon>{item.icon}</ListItemIcon>
        <ListItemText primary={item.title} />
      </StyledLinkItemButton>
    );

const MultiLevel = ({item}) => {
    const {items: children} = item;
    const {isOn, toggle} = useBoolFlag(false);


    return (
      <Fragment>
        <StyledLinkItemButton onClick={toggle}>
          <ListItemIcon>{item.icon}</ListItemIcon>
          <ListItemText primary={item.title} />
          {isOn ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </StyledLinkItemButton>
        <Collapse in={isOn} timeout='auto' unmountOnExit={false} mountOnEnter={false}>
          <List component='div' disablePadding>
            {children.map((child, key) => (
              <MenuItem key={key} menuItem={child} />
                    ))}
          </List>
        </Collapse>
      </Fragment>
    );
};

const visibilityFilter = ({visible}) => visible;

function createMapper(presentPermissions) {
    return function mapMenuEntry(item) {
        // checking whether item itself should be visible
        const visible = !item.permissions || (
            item.everyPermission ?
                item.permissions.every((requiredPermission) => presentPermissions.includes(requiredPermission)) :
                item.permissions.some((requiredPermission) => presentPermissions.includes(requiredPermission))
        );
        // checking and filtering child items
        const items = visible ? (item.items || []).map(mapMenuEntry).filter(visibilityFilter) : [];
        return {
            ...item,
            items,
            // item should be visible if permissions are present AND:
            // it has no children
            // OR at least some of its children are visible
            visible: visible && (item.items.length === 0 || items.length > 0),
        };
    };
}

export const Sidebar = ({user}) => {
    const filteredMenu = useMemo(() => menu.map(createMapper(user.permissions)).filter(visibilityFilter), [user.permissions]);
    return (
      <Box>{filteredMenu
            .map((item, key) => <MenuItem key={key} menuItem={item} />)}
      </Box>
    );
};

export default Sidebar;
